<template>
	<div class="container">
		<div class="page">
			<div class="contentBlock fontLarge">
				<div class="logoCentered paddingTop paddingBottomMore">
					<img
						:src="logoUrl"
						alt="Logo"
					/>
				</div>
			</div>
			<div class="contentBlock">
				<template v-if="error">
					<div class="errorMessage contentBlock marginBottom paddingBottom">
						We're sorry.&nbsp;&nbsp;{{ error }}
					</div>
				</template>
				<template v-else>
					<span class="fontLarge">We're sorry.</span>
					<br />
					<br />
					We were unable to retrieve the consignment contract requested. For assistance, please call
					the office at (919) 644-1243.
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	import contractState from '../../../mixins/contractState'
	export default {
		name: 'NotFound',
		mixins: [contractState],
		props: {
			error: {
				type: String,
				default: ''
			}
		},
		mounted() {}
	}
</script>

<style scoped></style>
